// ===== YUMYUM motion layer (decoration only) =====
// Commerce logic lives in site.js and never depends on this file.
// Bails on prefers-reduced-motion; anime.js loads lazily on idle.
(() => {
'use strict';
if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

const idle = window.requestIdleCallback || (cb => setTimeout(cb, 300));
const ready = new Promise(res => idle(() => res(import('./anime.esm.min.js'))));

// scale keyframes fight the buttons' CSS transition — suspend it while animating
function pop(el, animate, peak, dur){
  const prev = el.style.transition;
  el.style.transition = 'none';
  animate(el, {
    scale: [{to: peak, duration: 140}, {to: 1, duration: dur || 450}],
    ease: 'outElastic(1, .5)',
    onComplete: () => { el.style.transition = prev; el.style.transform = ''; }
  });
}

ready.then(({ animate }) => {

  // ---- Count-up social proof (server-rendered numbers, zeroed only at start) ----
  document.querySelectorAll('[data-countup]').forEach(el => {
    const target = parseInt(el.dataset.countup, 10);
    if (!target) return;
    const suffix = el.dataset.suffix || '';
    const cio = new IntersectionObserver(es => {
      if (!es[0].isIntersecting) return;
      cio.disconnect();
      const obj = { n: 0 };
      animate(obj, {
        n: target, duration: 1400, ease: 'outExpo',
        onUpdate: () => { el.textContent = Math.round(obj.n).toLocaleString('en-US') + suffix; }
      });
    }, { threshold: .4 });
    cio.observe(el);
  });

  // ---- PDP price ticker between ladder rungs ----
  document.addEventListener('yy:price-change', e => {
    const el = document.querySelector('.pdp-price');
    if (!el) return;
    // During a storewide sale the price element holds <s>was</s><now><pill>, so the
    // ticker must animate the .sale-now span only — writing textContent on the parent
    // would wipe the struck-through price and the pill.
    const S = window.YY_SALE, saleOn = !!(S && S.active && S.pct);
    const target = saleOn ? (el.querySelector('.sale-now') || el) : el;
    const num = s => parseFloat(String(s).replace(/[^0-9.]/g, ''));
    let from = num(e.detail.from), to = num(e.detail.to);
    if (!isFinite(from) || !isFinite(to) || from === to) return;
    if (saleOn) { const m = (100 - S.pct) / 100; from *= m; to *= m; }
    const fmt = n => '$' + (Math.round(n * 100) % 100 === 0 ? n.toFixed(0) : n.toFixed(2));
    const dec = (Math.round(to * 100) % 100 === 0) ? 0 : 2;
    const obj = { n: from };
    animate(obj, {
      n: to, duration: 420, ease: 'outQuad',
      onUpdate: () => { target.textContent = '$' + obj.n.toFixed(dec); },
      onComplete: () => { target.textContent = fmt(to); }
    });
    const note = document.querySelector('.pdp-price-note');
    if (note) pop(note, animate, 1.1, 400);
  });

  // ---- Add-to-cart success feedback ----
  document.addEventListener('yy:atc-added', e => {
    const btn = e.detail && e.detail.btn;
    if (btn) pop(btn, animate, 1.05, 420);
    const cc = document.getElementById('cartCount');
    if (cc) pop(cc, animate, 1.45, 500);
  });

  // ---- Free-shipping unlocked celebration (AU drawer only — event never fires intl) ----
  document.addEventListener('yy:ship-unlocked', () => {
    const msg = document.getElementById('shipBarMsg');
    const fill = document.getElementById('shipBarFill');
    if (msg) pop(msg, animate, 1.14, 550);
    if (fill){
      const settled = getComputedStyle(fill).backgroundColor;
      animate(fill, {
        backgroundColor: ['#F6BB1A', settled], duration: 900, ease: 'outQuad',
        onComplete: () => { fill.style.backgroundColor = ''; }
      });
    }
  });

}).catch(() => {}); // decoration must never break the store
})();
